var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitiBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Citi_Bank"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 444697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 6L12.4 6.85V8.45H11V9.95001H12.4V14.45C12.4 15.65 13.1 16.5 14.2 16.55C14.7 16.55 15.2 16.45 15.65 16.2L16.05 14.65L16 14.7C15.65 14.95 15.2 15.1 14.8 15.1C14.25 15.1 14 14.85 14 14.2V9.95001H15.65V8.45H14V6ZM4.15 8.35C3.1 8.35 2.05 8.7 1.25 9.4C0.850001 9.8 0.500001 10.25 0.3 10.8C0.1 11.35 0 11.9 0 12.45C0 13 0.1 13.6 0.3 14.1C0.500001 14.65 0.850001 15.1 1.25 15.5C2.05 16.2 3.1 16.6 4.15 16.55C4.70001 16.55 5.25001 16.45 5.70001 16.2C6.15001 15.95 6.60001 15.65 6.95001 15.2L7.00001 15.15L6.05001 14L6.00001 14.05C5.75001 14.3 5.45001 14.55 5.10001 14.7C4.75001 14.85 4.40001 14.95 4.05 14.95C3.7 14.95 3.4 14.9 3.05 14.75C2.75 14.6 2.45 14.45 2.2 14.2C1.95 13.95 1.8 13.65 1.65 13.35C1.55 13.05 1.5 12.7 1.5 12.35C1.5 12 1.55 11.7 1.65 11.35C1.75 11.05 1.95 10.75 2.2 10.5C2.45 10.25 2.7 10.05 3.05 9.95001C3.35 9.8 3.7 9.75001 4.05 9.80001C4.40001 9.80001 4.80001 9.90001 5.10001 10.05C5.45001 10.2 5.75001 10.4 6.00001 10.7L6.05001 10.75L7.00001 9.65V9.7C6.65001 9.25 6.25001 8.9 5.75001 8.7C5.25001 8.45 4.70001 8.35 4.15 8.35ZM7.95001 8.45H9.55001V16.4H7.95001V8.45ZM17.3 8.45H18.95V16.4H17.35C17.35 16.45 17.3 8.45 17.3 8.45Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.9 6.35C19.15 5.3 18.2 4.45 17.05 3.85C15.9 3.25 14.7 3 13.45 3C12.2 3 10.9 3.3 9.79998 3.9C8.64998 4.5 7.69998 5.35 6.94998 6.4L6.84998 6.5H8.74998C9.34998 5.85 10.05 5.35 10.9 5C11.75 4.65 12.55 4.45 13.45 4.45C14.35 4.45 15.2 4.65 16 5C16.8 5.35 17.55 5.85 18.15 6.5H20L19.9 6.35Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiBank);
export default __webpack_public_path__ + "static/media/citi_bank.d947bc1beb452669297270abb4b3a7c5.svg";
export { ForwardRef as ReactComponent };